import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/**
 * Relative age of a timestamp, e.g. "an hour ago".
 *
 * Note `dayjs(date).fromNow()`, not the platform's `dayjs().from(date)` - the
 * latter reads the interval from the other end and renders past timestamps as
 * "in an hour".
 */
export function fromNow(date) {
  if (!date) {
    return '';
  }
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.fromNow() : '';
}
